(() => {
  if (window.DDIPadCardHeights) return;

  const mediaQuery = window.matchMedia('(min-width: 750px) and (max-width: 1366px)');
  const trackSelector = '.dd-jagged-collection-cards .dd-card-row__track, .dd-recipes-index__grid, .dd-card-row__track';
  const itemSelector = '.dd-jagged-collection-cards__item, .dd-recipes-index__item, .dd-recipe-card-item';
  const cardSelector = '.dd-jagged-collection-card, .dd-recipe-card--jagged';
  let frame = 0;

  const isIPad = () => navigator.maxTouchPoints > 1
    && (/iPad/i.test(navigator.userAgent) || navigator.platform === 'MacIntel');

  const directItems = (track) => [...track.children].filter((item) => {
    if (!item.matches(itemSelector)) return false;
    return [...item.children].some((child) => child.matches(cardSelector));
  });

  const directCard = (item) => [...item.children].find((child) => child.matches(cardSelector));

  const resetItems = (items) => {
    items.forEach((item) => {
      item.removeAttribute('data-dd-ipad-card-equalized');
      item.style.removeProperty('--dd-ipad-card-equal-height');
    });
  };

  const equalizeTrack = (track) => {
    const items = directItems(track);
    if (!items.length) return;

    resetItems(items);
    void track.offsetHeight;

    const rows = [];
    items.forEach((item) => {
      const card = directCard(item);
      if (!card || item.offsetParent === null) return;

      const top = item.offsetTop;
      let row = rows.find((candidate) => Math.abs(candidate.top - top) <= 2);
      if (!row) {
        row = { top, entries: [] };
        rows.push(row);
      }
      row.entries.push({ item, card });
    });

    rows.forEach((row) => {
      const height = Math.ceil(Math.max(...row.entries.map(({ card }) => card.getBoundingClientRect().height)));
      if (!Number.isFinite(height) || height <= 0) return;
      row.entries.forEach(({ item }) => {
        item.style.setProperty('--dd-ipad-card-equal-height', `${height}px`);
        item.setAttribute('data-dd-ipad-card-equalized', '');
      });
    });
  };

  const sync = () => {
    frame = 0;
    const active = isIPad() && mediaQuery.matches;
    document.documentElement.classList.toggle('dd-ipad-card-layout', active);

    const tracks = [...document.querySelectorAll(trackSelector)].filter((track) => directItems(track).length);
    if (!active) {
      tracks.forEach((track) => resetItems(directItems(track)));
      return;
    }
    tracks.forEach(equalizeTrack);
  };

  const schedule = () => {
    if (frame) window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => {
      frame = window.requestAnimationFrame(sync);
    });
  };

  const start = () => {
    schedule();
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    window.addEventListener('load', schedule, { once: true });
    document.addEventListener('load', (event) => {
      if (event.target instanceof HTMLImageElement && event.target.closest(cardSelector)) schedule();
    }, true);
    document.addEventListener('dd:recipes:appended', schedule);
    document.addEventListener('shopify:section:load', schedule);

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.nodeType === Node.ELEMENT_NODE && (node.matches?.(itemSelector) || node.querySelector?.(itemSelector))))) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.fonts?.ready.then(schedule);
  };

  window.DDIPadCardHeights = { schedule };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
